/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { authInfo } from "../funcs/authInfo.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import {
  SessionInfoRequest,
  SessionInfoResponse,
  SessionInfoSecurity,
} from "../models/operations/sessioninfo.js";
import { unwrapAsync } from "../types/fp.js";
export type SessionInfoQueryData = SessionInfoResponse;

export function prefetchSessionInfo(
  queryClient: QueryClient,
  client$: GramCore,
  request?: SessionInfoRequest | undefined,
  security?: SessionInfoSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildSessionInfoQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildSessionInfoQuery(
  client$: GramCore,
  request?: SessionInfoRequest | undefined,
  security?: SessionInfoSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<SessionInfoQueryData>;
} {
  return {
    queryKey: queryKeySessionInfo({ gramSession: request?.gramSession }),
    queryFn: async function sessionInfoQueryFn(
      ctx,
    ): Promise<SessionInfoQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(authInfo(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeySessionInfo(
  parameters: { gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "auth", "info", parameters];
}
